import { Component, AfterViewInit, Input, ViewChild } from '@angular/core';
import { Ship } from '../../../../Models/ship';
import { Mark } from '../../models/mark';
import { ApiHereService } from '../../services/api.here.service';
import { OneCoreMapHereComponent } from '../one-core-map-here/one-core-map-here.component';
import { Address } from '../../../../Models/address';
import { OpenStreetMapService } from '../../services/open-street-map.service';

@Component({
  selector: 'layout-map',
  templateUrl: './layout-map.component.html',
  styleUrls: ['./layout-map.component.scss']
})
export class LayoutMapComponent implements AfterViewInit {
  filter: any = { };
  @Input() ships: Ship[] = [];
  marks: Mark[] = [];
  @Input() start: Address;
  @Input() end: Address;
  @ViewChild('map') map: OneCoreMapHereComponent;
  constructor(private apiHereService: ApiHereService, private openStreetMapService: OpenStreetMapService) {
    this.ships.push({
      id: 2, destination: {
        latitude: 27.489726,
        longitude: -109.962083
      }
    });
    this.ships.push({
      id: 1, destination: {
        country: 'México',
        state: 'Sonora',
        neighborhood: 'Morelos',
        zipCode: 85110,
        extNumber: 429,
        intNumber: 1,
        street: 'Atil',
      }
    });
    this.ships.push({
      id: 4, destination: {
        latitude: 27.499537,
        longitude: -109.946977
      }
    });
    this.ships.push({
      id: 3, destination: {
        latitude: 27.495957,
        longitude: -109.956751
      }
    });
    this.start = {
      id: 1,
      country: 'México',
      state: 'Sonora',
      neighborhood: 'Centro',
      zipCode: 85000,
      extNumber: 536,
      intNumber: 1,
      street: 'Puebla',
    };
    this.end = {
      id: 1,
      country: 'México',
      state: 'Sonora',
      neighborhood: 'Centro',
      zipCode: 85000,
      extNumber: 536,
      intNumber: 1,
      street: 'Puebla',
    };
  }
  ngAfterViewInit(): void {
    this.apiHereService.getMarksFromShips(this.ships).subscribe((marks) => {
      this.marks = marks;
      this.map.clearMarks();
      this.setStartEnd();
      this.map.createMarks(this.marks);
    });
  }
  setStartEnd() {
    if (this.start) {
      this.openStreetMapService.getCordenadasByAddress(this.start).subscribe((result) => {
        this.start.latitude = result[0].lat;
        this.start.longitude = result[0].lon;
        this.map.setStartMarks(
          {
            id: this.start.id,
            lat: result[0].lat,
            lng: result[0].lon,
            data: this.start
          }
        );
      });
    }
    if (this.end) {
      this.openStreetMapService.getCordenadasByAddress(this.end).subscribe((result) => {
        this.end.latitude = result[0].lat;
        this.end.longitude = result[0].lon;
        this.map.setEndMarks(
          {
            id: this.end.id,
            lat: result[0].lat,
            lng: result[0].lon,
            data: this.end
          }
        );
      });
    }
  }

  optimize(evt?: any) {
    let order = this.apiHereService.getShipSequence(this.ships, this.start);
    this.apiHereService.getMarksFromShips(order.map(item => item.shipment)).subscribe((marks) => {
      this.marks = marks;
      this.map.setOrder(this.marks);
      this.paintRoute();
    });
  }
  paintRoute(evt?: any) {
    this.map.clearMarks();
    this.map.createMarks(this.marks);
    this.setStartEnd();
    this.map.paintRoute();
  }
  search(evt?: any) {
    this.openStreetMapService.getCordenadasByText(this.filter.textSearch).subscribe((result) => {
      this.end.latitude = result[0].lat;
      this.end.longitude = result[0].lon;
      this.map.addSearchMarks(
        {
          id: this.end.id,
          lat: result[0].lat,
          lng: result[0].lon,
          data: this.end
        }
      );
    });
  }
  changeMarker(mark: any) {
    this.marks.forEach((item) => {
      if (mark.id == item.id) {
        item.lat = mark.lat || mark.getPosition().lat;
        item.lng = mark.lng || mark.getPosition().lng;
      }
    })
  }
}
